import { styled } from "@mui/material/styles";
import { Box, Paper } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const StepContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  minHeight: "400px",
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2),
    minHeight: "300px",
  },
}));

export const FeatureCard = styled(Paper)(({ theme, color }) => ({
  padding: theme.spacing(2.5),
  borderRadius: theme.spacing(2),
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  transition: "all 0.3s ease",
  height: "100%",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: theme.shadows[4],
    borderColor: alpha(color || theme.palette.primary.main, 0.3),
  },
}));

export const ChecklistItem = styled(Box)(({ theme, completed }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1.5),
  backgroundColor: completed
    ? alpha(theme.palette.success.main, 0.08)
    : alpha(theme.palette.grey[500], 0.04),
  border: `2px solid ${
    completed
      ? alpha(theme.palette.success.main, 0.3)
      : alpha(theme.palette.divider, 0.1)
  }`,
  marginBottom: theme.spacing(1.5),
}));

export const PlatformCard = styled(Paper)(({ theme, platformColor }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(3),
  border: `2px solid ${alpha(platformColor || theme.palette.primary.main, 0.2)}`,
  textAlign: "center",
  cursor: "pointer",
  transition: "all 0.3s ease",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  "&:hover": {
    boxShadow: theme.shadows[8],
    borderColor: platformColor || theme.palette.primary.main,
    transform: "translateY(-4px)",
  },
}));
